<template>
  <div v-if="ordreTravail">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{$t('detailOrdreTravailTech.title', { code: ordreTravail.code })}}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">

            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :permission="constantes.ORDRE_TRAVAIL.maj"
              :actions="actionSecondary"
              @click="() => {
                $router.push({ name: 'm.logistique.ordre_travail-techEdition',
                  params: { id: ordreTravail.id}});
              }">
                {{ $t('general.button.edit') }}
            </dropdownButton>
            <qd-button
              v-if="isOTImpression && !ordreTravail.fournisseurId"
              @click="openPopUpFournisseur()"
              :class="[
                { 'button-access-no-permission': !checkPermissions(constantes.ORDRE_TRAVAIL.maj) },
              ]"
              class="button is-addOrEdit">
              {{ $t('detailOrdreTravailTech.actions.prisEnCharge') }}
            </qd-button>
             <button class="button"
                    :class="{'button-access-no-permission':
                    !checkPermissions(constantes.ORDRE_TRAVAIL.lecture)}"
                    @click="checkPermissions(constantes.ORDRE_TRAVAIL.lecture) ?
                    openPopUpEmail() : showPopUp()">
              <b-icon icon="email-plus" type="is-default"></b-icon>
            </button>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown ref="dropdownEdition" position="is-bottom-left">
                  <div slot="trigger">
                    <b-icon icon="chevron-down"
                            class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item class="has-text-left"
                                   @click="checkPermissions(constantes.ORDRE_TRAVAIL.editer) ?
                                   edition(constantes.TYPE_PDF)
                                  : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item class="has-text-left"
                                   @click="checkPermissions(constantes.ORDRE_TRAVAIL.editer) ?
                                   edition(constantes.TYPE_DOCX)
                                  : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <a class="button"  @click="checkPermissions(constantes.ORDRE_TRAVAIL.maj) ?
                      showAddAttachmentModal() : showPopUp()">
              <b-icon icon="paperclip" type="is-default"/>
            </a>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messagesErreurEdition"
                          :error="isErrorEdition"
                          :title="'general.problemOccurred'"
                          @close="isErrorEdition = $event"/>
      <header-info-ot-patrimoine :ot="ordreTravail" :is-detail="true">
      </header-info-ot-patrimoine>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'caracteristique'}"
              @click="activeTab = 'caracteristique'">
            {{ $t('detailOrdreTravailTech.onglet.caracterique') }}
          </li>
          <li :class="{'is-active': activeTab === 'patrimoine'}"
              @click="activeTab = 'patrimoine'">
            {{ $t('detailOrdreTravailTech.onglet.patrimoine') }}
          </li>
          <li :class="{'is-active': activeTab === 'demande'}"
              @click="activeTab = 'demande'">
            {{ $t('detailOrdreTravailTech.onglet.demande') }}
          </li>
          <li :class="{'is-active': activeTab === 'bilan'}"
              @click="activeTab = 'bilan'">
            {{ $t('detailOrdreTravailTech.onglet.bilan') }}
          </li>
          <li v-if="hasPatrimoine && !isEmplacement"
              :class="{'is-active': activeTab === 'nomenclatureTechnique'}"
              @click="activeTab = 'nomenclatureTechnique'">
            {{ $t('nomenclatureTechnique.title') }}
          </li>
          <li :class="{'is-active': activeTab === 'lieuDeLivraison'}"
            v-if="moduleStockTiersActive && (isOTImpression || isOTPoseDispositif)"
              @click="activeTab = 'lieuDeLivraison'">
            {{ $t('detailOrdreTravailTech.onglet.lieuDeLivraison') }}
          </li>
        </ul>
      </div>
      <component :is="activeTab"
                 :ordreTravail="ordreTravail"
                 :item="ordreTravail.otPatrimoine"
                 :isOTImpression="isOTImpression"
                 :disabled="true">
      </component>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('detailOrdreTravailTech.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :questions="questionsPopUpPrevention"
        :isErrorPopup.sync="errorPopUp"
        :messagesPopup="messagesErreurPopUp"
        @no="popUpSuppression = false"
        @validateQuestions="deleteOt"/>
    </b-modal>
    <b-modal v-model="popUpMail" has-modal-card class="modal">
      <pop-up-mail
        :mail="mail"
        :title="'detailFacture.popUpMail.title'"
        :error="errorEmail"
        :editionsAInclure="editionsAInclure"
        @sendEmail="envoieMail()">
      </pop-up-mail>
    </b-modal>
    <b-modal v-model="isComponentChangerEtatOtTechnique" has-modal-card class="modal">
      <pop-up-changer-etat
        :ordreTravail="ordreTravail"
        :etatAchanger="etatAchanger"
        :messageHeader="messageHeader"
        :moduleEmplacementClientActive="moduleEmplacementClientActive"
        @close="isComponentChangerEtatOtTechnique = false"
        @update="updateEtat">
      </pop-up-changer-etat>
    </b-modal>
    <b-modal v-model="popUpSelectTechnicien" has-modal-card class="modal">
      <pop-up-technicien-select
        :messHeader="$t('detailOrdreTravailTech.popUpFournisseurTitle')"
        :otIds="[ordreTravail.id]"
        :cancelButtonText="$t('general.non')"
        :validateButtonText="$t('general.oui')"
        @cancel="popUpSelectTechnicien = false"
        @done="loadOtTechniqueInformation"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import edition from '@/api/edition/index';
import messageErreur from '@/services/general/messageErreur';
import dropdownButton from '@/components/general/button/dropdownButton';
import { get, deleteOt } from '@/api/logistique/ordreTravailTech';
import { fillInfoOtPatrimoine } from '@/services/logistique/ordreTravail/tech/fillInfoOtPatrimoine';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import breadcrumb from '@/components/general/breadcrumb';
import bilan from '@/components/logistique/ordreTravail/tech/detail/bilan';
import caracteristique
  from '@/components/logistique/ordreTravail/tech/detail/caracterisques/caracteristiques';
import patrimoine from '@/components/logistique/ordreTravail/tech/detail/patrimoine/patrimoine';
import demande from '@/components/logistique/ordreTravail/tech/detail/demande';
import nomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  AUCUN,
  MONTAGE,
  DEMONTAGE,
  LISTE_ACTION_INTERVENTION,
  IMPRESSION_AFFICHE,
  FABRICATION_DISPOSITIF,
  DISPOSITIF_FABRIQUE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import {
  ETAT_EN_COURS,
  ETAT_REALISE,
  ETAT_ANNULE,
  ETAT_EN_ATTENTE,
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
  ETAT_PLANIFIE,
  LIST_ETAT_OT_TECH,
  ETAT_CLOTURER,
  ETAT_A_EXPEDIER,
  ETAT_EXPEDIE,
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_FABRICATION,
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_POSE,
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import envoieMailOtTech from '@/services/logistique/ordreTravail/tech/envoieMailOtTech';
import validationEnvoieMail from '@/services/general/validation/validationEnvoieMail';
import popUpMail from '@/components/general/p_mail';
import headerInfoOtPatrimoine
  from '@/components/logistique/ordreTravail/tech/headerInfoOtPatrimoine';
import generationMailPourOtTech from '@/services/logistique/ordreTravail/tech/generationMailPourOtTech';
import popUpChangerEtat from '@/components/logistique/ordreTravail/tech/popUpChangerEtat';
import validationSave from '@/services/logistique/ordreTravail/tech/validation/validation';
import lieuDeLivraison from '@/components/logistique/ordreTravail/tech/addEdit/lieuDeLivraison/c_lieuDeLivraison';
import popUpTechnicienSelect from '@/components/logistique/ordreTravail/impression/popUpTechnicienSelect';
import validationImpressionEdition from '@/services/logistique/demandeImpression/validationRetourEdition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      ordreTravail: null,
      popUpMail: false,
      activeTab: 'caracteristique',
      constantes: {
        ORDRE_TRAVAIL,
        ETAT_EN_COURS,
        ETAT_REALISE,
        ETAT_ANNULE,
        ETAT_EN_ATTENTE,
        ETAT_PLANIFIE,
        ETAT_CLOTURER,
        AUCUN,
        LISTE_ACTION_INTERVENTION,
        TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE,
        TYPE_PDF,
        TYPE_DOCX,
        IMPRESSION_AFFICHE,
        TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_POSE,
        TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_FABRICATION,
        TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION,
      },
      isComponentChangerEtatOtTechnique: false,
      otTechnique: [],
      etatAchanger: null,
      mail: null,
      messageHeader: '',
      popUpSuppression: false,
      messagesErreurPopUp: [],
      messagesErreurEdition: [],
      isErrorEdition: false,
      errorPopUp: false,
      editionsAInclure: [{ libelle: 'detailOrdreTravailTech.popUpMail.inclureOt', key: 'mettreEdition', value: true }],
      messagesPopup: [''],
      isErrorPopup: false,
      questionsPopUpPrevention: [],
      errorEmail: {
        haveError: false,
        messages: [],
      },
      popUpSelectTechnicien: false,
    };
  },
  components: {
    breadcrumb,
    bilan,
    dropdownButton,
    caracteristique,
    patrimoine,
    demande,
    popUpPrevention,
    headerInfoOtPatrimoine,
    popUpMail,
    popUpChangerEtat,
    nomenclatureTechnique,
    lieuDeLivraison,
    popUpTechnicienSelect,
    errorMsgComponent,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getLibelleEtat() {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === this.ordreTravail.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailOrdreTravailTech.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail-tech' }, isActive: false },
        { title: this.$t('detailOrdreTravailTech.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.delete'),
          action: () => { this.openPopUpSuppression(); },
          permissionAction: ORDRE_TRAVAIL.supprimer,
        },
      ];
      if (this.ordreTravail.etat !== ETAT_REALISE) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.realise'),
            action: () => { this.changerEtatOtTechnique(ETAT_REALISE); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_EN_ATTENTE) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.enAttente'),
            action: () => { this.changerEtatOtTechnique(ETAT_EN_ATTENTE); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_PLANIFIE) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.planifie'),
            action: () => { this.changerEtatOtTechnique(ETAT_PLANIFIE); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_EN_COURS) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.enCours'),
            action: () => { this.changerEtatOtTechnique(ETAT_EN_COURS); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_ANNULE) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.annuler'),
            action: () => { this.changerEtatOtTechnique(ETAT_ANNULE); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_CLOTURER) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.cloture'),
            action: () => { this.changerEtatOtTechnique(ETAT_CLOTURER); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_A_EXPEDIER && this.moduleImpressionActive
          && this.isOTImpression) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.aExpedier'),
            action: () => { this.changerEtatOtTechnique(ETAT_A_EXPEDIER); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      if (this.ordreTravail.etat !== ETAT_EXPEDIE && this.moduleImpressionActive
        && this.isOTImpression) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailTech.actions.expedie'),
            action: () => { this.changerEtatOtTechnique(ETAT_EXPEDIE); },
            permissionAction: ORDRE_TRAVAIL.maj,
          },
        );
      }
      return actions.sort((a, b) => a.label.localeCompare(b.label));
    },
    isEmplacement() {
      return this.ordreTravail?.otPatrimoine?.emplacementId;
    },
    hasPatrimoine() {
      return this.ordreTravail?.otPatrimoine;
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
    isOTImpression() {
      return this.parametre(PARAMETRES_KEYS.typeOt)
        .find((t) => t.id === this.ordreTravail?.typeOtId)
        ?.actionInterventionOt === IMPRESSION_AFFICHE;
    },
    isOTPoseDispositif() {
      return this.parametre(PARAMETRES_KEYS.typeOt)
        .find((t) => t.id === this.ordreTravail?.typeOtId)
        ?.actionInterventionOt === DISPOSITIF_FABRIQUE;
    },
    editionType() {
      switch (this.ordreTravail.typeOt?.actionInterventionOt) {
        case FABRICATION_DISPOSITIF:
          return this.constantes.TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_FABRICATION;
        case IMPRESSION_AFFICHE:
          return this.constantes.TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION;
        case DISPOSITIF_FABRIQUE:
          return this.constantes.TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_POSE;
        default:
          return this.constantes.TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE;
      }
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      showAddAttachmentModal: 'showAddModal',
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    changerEtatOtTechnique(etatSouhaite) {
      switch (etatSouhaite) {
        case ETAT_EN_COURS:
          this.isComponentChangerEtatOtTechnique = true;
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgEncoursOt');
          this.etatAchanger = ETAT_EN_COURS;
          break;
        case ETAT_EN_ATTENTE:
          this.isComponentChangerEtatOtTechnique = true;
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgEnAttenteOt');
          this.etatAchanger = ETAT_EN_ATTENTE;
          break;
        case ETAT_ANNULE:
          this.questionsPopUpPrevention = [];
          this.messageHeader = this.ordreTravail?.otStock?.bonStockId ? this.$t('detailOrdreTravailTech.popup.msgAnnulerOtAvecBon') : this.$t('detailOrdreTravailTech.popup.msgAnnulerOt');
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_ANNULE;
          break;
        case ETAT_PLANIFIE:
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgPlanifierOt');
          this.isComponentChangerEtatOtTechnique = true;
          this.etatAchanger = ETAT_PLANIFIE;
          break;
        case ETAT_REALISE:
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgRealiserOt');
          this.etatAchanger = ETAT_REALISE;
          this.isComponentChangerEtatOtTechnique = true;
          break;
        case ETAT_CLOTURER:
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgCloturerOt');
          this.etatAchanger = ETAT_CLOTURER;
          this.isComponentChangerEtatOtTechnique = true;
          break;
        case ETAT_A_EXPEDIER:
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgAExpedierOt');
          this.etatAchanger = ETAT_A_EXPEDIER;
          this.isComponentChangerEtatOtTechnique = true;
          break;
        case ETAT_EXPEDIE:
          this.messageHeader = this.$t('detailOrdreTravailTech.popup.msgExpedieOt');
          this.etatAchanger = ETAT_EXPEDIE;
          this.isComponentChangerEtatOtTechnique = true;
          break;
        default:
          break;
      }
    },
    async envoieMail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        await envoieMailOtTech(this.mail, this.editionsAInclure[0].value,
          this.ordreTravail.societeId, this.ordreTravail.id);
        messageSucces(this.$i18n.t('mail.success.envoie'));
        this.popUpMail = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEnvoieMail(e.response, this.errorEmail.messages);
          this.errorEmail.haveError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async openPopUpEmail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        this.mail = await generationMailPourOtTech(
          this.ordreTravail.fournisseurId,
          this.user,
        );
        this.mail.objet = this.$i18n.t('detailOrdreTravailTech.popUpMail.otObject', {
          code: this.ordreTravail.code,
        });
        this.popUpMail = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async loadOtTechniqueInformation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        const ordreTravail = (await get(this.$route.params.id)).data.result;
        await fillInfoOtPatrimoine(ordreTravail.otPatrimoine, true);
        await this.setAttachmentElementId({ id: ordreTravail.id });
        this.ordreTravail = ordreTravail;
        this.ordreTravail.otPatrimoine = this.parserNomenclature(this.ordreTravail.otPatrimoine);
        this.setInformationPage(this.$t('pageGeneral.detail', { item: this.ordreTravail.code }));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async updateEtat() {
      this.isComponentChangerEtatOtTechnique = false;
      await this.loadOtTechniqueInformation();
    },
    async deleteOt(questions) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let isAnnulatonSuppression = false;
        if (questions && questions
          .find((q) => { return q.key === 'isAnnulatonSuppression'; })) {
          isAnnulatonSuppression = this.questionsPopUpPrevention.find((q) => {
            return q.key === 'isAnnulatonSuppression';
          }).value;
        }
        await deleteOt(this.$route.params.id, isAnnulatonSuppression);
        messageSucces(this.$t('detailOrdreTravailTech.messages.success.otDelete'));
        loadingComponent.close();
        await this.$router.push({ name: 'l.logistique.ordre_travail-tech' });
      } catch (e) {
        if (e.response) {
          validationSave(e.response, this.messagesErreurPopUp, [this.ordreTravail]);
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      }
    },
    getActionInterventionLibelle(typeOtAction) {
      const actionFind = LISTE_ACTION_INTERVENTION.find((actionInter) => {
        return actionInter.code === typeOtAction;
      });
      return actionFind ? this.$i18n.t(actionFind.libelle) : '';
    },
    async edition(format) {
      this.messagesErreurEdition = [];
      this.isErrorEdition = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.ordreTravail.id],
          extension: format,
          typeDonnee: this.editionType,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationImpressionEdition(response, this.messagesErreurEdition);
          this.isErrorEdition = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
    openPopUpSuppression() {
      this.questionsPopUpPrevention = [];
      if (this.ordreTravail.otPatrimoine
        && (this.ordreTravail.typeOt.actionInterventionOt === MONTAGE
        || this.ordreTravail.typeOt.actionInterventionOt === DEMONTAGE)) {
        this.questionsPopUpPrevention = [{
          key: 'isAnnulatonSuppression',
          value: true,
          message: this.ordreTravail.typeOt.actionInterventionOt === MONTAGE
            ? 'detailOrdreTravailTech.popUpSuppression.demonter'
            : 'detailOrdreTravailTech.popUpSuppression.monter',
        }];
      }
      this.popUpSuppression = true;
    },
    parserNomenclature(otPatrimoine) {
      if (otPatrimoine?.nomenclature) {
        otPatrimoine.nomenclature = JSON.parse(otPatrimoine.nomenclature);
      }
      return otPatrimoine;
    },
    openPopUpFournisseur() {
      if (!this.checkPermissions(ORDRE_TRAVAIL.maj)) {
        this.showPopUp();
        return;
      }
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.popUpSelectTechnicien = true;
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      PARAMETRES_INTERNE_KEYS.demandeImpression.key,
    ]);
    await this.loadParametres([PARAMETRES_KEYS.typeOt]);
    await this.loadOtTechniqueInformation();
  },
};

</script>
